import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useCallback, useRef } from "react";
import { loadUserProfile } from "../../redux/actions/authActions";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";

const FormModalUpdatePresentationPresta = ({ onClose }) => {
    const { token } = useSelector((state) => state.auth);
    const profilPrestataire = useSelector((state) => state.profil.prestataire);

    const apiUrl = process.env.REACT_APP_API_URL;

    const [errors, setErrors] = useState({});
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        emergencyPossible: profilPrestataire.isEmergencyInterventionPossible,
        isCesuAccepted: profilPrestataire.isCesuAccepted,
        presentationText: profilPrestataire.descriptionPrestataire,
    });
    const isStepValid = !errors.presentationText;


    const validateField = (name, value) => {
        let fieldErrors = { ...errors };

        switch (name) {
            case "presentationText":
                if (!value || value.trim().length < 20) {
                    fieldErrors.presentationText = "Votre présentation doit contenir au moins 20 caractères.";
                } else {
                    delete fieldErrors.presentationText;
                }
                break;

            default:
                break;
        }

        setErrors(fieldErrors);
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        let newValue = type === "checkbox" ? checked : value;

        setFormData((prev) => ({
            ...prev,
            [name]: newValue,
        }));

        validateField(name, newValue);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Object.keys(errors).length > 0) {
            alert("Veuillez corriger les erreurs avant de soumettre.");
            return;
        }

        try {
            const form = new FormData();

            Object.keys(formData).forEach(key => {
                form.append(key, formData[key]);
            });

            const response = await fetch(`${apiUrl}/api/updateProfil/prestataire`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,
            });

            if (!response.ok) {
                const errorData = await response.json();
                alert(errorData.message || "Une erreur est survenue lors de la mise à jour.");
                return;
            }

            await response.json();
            setUpdateSuccess(true);
            dispatch(fetchProfilPrestataire(token));
            setTimeout(() => {
                onClose();
            }, 800);

        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error);
            alert("Impossible de se connecter au serveur. Réessayez plus tard.");
        }
    };

    return (
        <div className="inscriptionModalOverlay">
            <div className="inscriptionModal">
                <button className="inscriptionModalClose" onClick={onClose}>×</button>
                <form onSubmit={handleSubmit}>
                    <h2>Présentation de l'entreprise</h2>

                    <div className="inscriptionPrestataireModal-input-form">
                        <label>Texte de présentation</label>
                        <textarea
                            name="presentationText"
                            value={formData.presentationText || ""}
                            onChange={handleChange}
                            rows={6}
                            placeholder="Décrivez vos services, votre expérience, vos points forts..."
                            required
                        />
                        {errors.presentationText && (
                            <p className="error-text">{errors.presentationText}</p>
                        )}
                    </div>
                    <div className="inscriptionPrestataireModal-input-form">
                        <label>
                            <input
                                type="checkbox"
                                name="emergencyPossible"
                                checked={formData.emergencyPossible || false}
                                onChange={handleChange}
                            />
                            Je peux intervenir d'urgence 24h/24 7j/7
                        </label>
                    </div>

                    <div className="inscriptionPrestataireModal-input-form">
                        <label>
                            <input
                                type="checkbox"
                                name="isCesuAccepted"
                                checked={formData.isCesuAccepted || false}
                                onChange={handleChange}
                            />
                            J'accepte les paiements CESU
                        </label>
                    </div>



                    <div className="inscriptionClientModal-actions">

                        <button
                            type="submit"
                            disabled={!isStepValid}

                        >
                            ENREGISTRER
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FormModalUpdatePresentationPresta;
